import { isRequired } from '../../../utils/validation';

export const initialValues = {
  activePeriod: '',
  regional: '',
  status: false
};
export const fieldsProps = {
  regional: {
    name: 'regional',
    placeholder: 'Pilih regional',
    label: 'Regional',
  },
  province: {
    name: 'province',
    placeholder: 'Pilih provinsi',
    label: 'Provinsi'
  },
  city: {
    name: 'city',
    placeholder: 'Pilih kota/kabupaten',
    label: 'Kota/Kabupaten',
  },
  district: {
    name: 'district',
    placeholder: 'Pilih kecamatan',
    label: 'Kecamatan',
  },
  village: {
    name: 'village',
    placeholder: 'Pilih kelurahan',
    label: 'Kelurahan',
  },
  activePeriod: {
    name: 'activePeriod',
    placeholder: 'Pilih Periode Aktif Pencatatan Manual',
    label: 'Periode Aktif Pencatatan Manual',
    data: [
      { label: '1 Hari', value: '1' },
      { label: '3 Hari', value: '3' },
      { label: '7 Hari', value: '7' },
      { label: '30 Hari', value: '30' },
      { label: 'Tanpa Batas Waktu', value: '0', disabled: true },
    ],
  }
};

export const validate = (values = initialValues) => {
  const { period, regional } = values;
  const rules = {
    regional: isRequired(regional, 'Regional harus dipilih'),
    period: isRequired(period, 'Periode Aktif Pencatatan Manual harus dipilih'),
  };

  return rules;
};
